import '../../css/bootstrap/bootstrap.min.css';
import 'fastmodel-utility-classes';
import 'react-fast-ui/css/index.css';
import 'react-select/dist/react-select.min.css';
import 'react-date-picker/index.css';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import '../../css/style.scss';
import 'babel-polyfill';
import moment from 'moment';
import Promise from 'bluebird';
import { replaceHash } from 'replace-hash';

// Enable promise cancellation
Promise.config({
  cancellation: true
});

if (window) {
  // Configure moment's locale based on the navigator
  let locales = window.navigator.language;
  if (window.navigator.languages) {
    locales = window.navigator.languages;
  }
  moment.locale(locales);

  replaceHash();
}


// WEBPACK FOOTER //
// ./src/js/common/Common.jsx